<template>
  <div class="block card upcomming-offer">
    <title-block :imagePath="logoBlockUrl" :title="$t('DashboardPageManager.block_first_title')" imageAlt="logo"></title-block>

    <div class="block_content button-wrapper mt-2">
      <button class="btn btn-cons btn-my-request btn-ellipsis"
              v-bind:class="is_actived ? 'btn-primary' : 'btn-secondary-dark'"
              @click="offersPublishedByMe()">
        <b>{{ $t('DashboardPageManager.my_requests') }}</b></button>
      <button class="btn btn-cons btn-all btn-ellipsis"
              v-bind:class="is_actived ? 'btn-secondary-dark' : 'btn-primary'"
              @click="offersPublishedAll()">
        <b>{{ $t('DashboardPageManager.all') }}</b></button>
    </div>

    <div class="block_content content-wrapper">
      <sub-title
        :subTitle="$t('Offers.status.manager.published')"
        :number="countOffersPublished"
        :color="'orange'">
      </sub-title>

      <div class="published-offers">
        <div class="table-published">
          <UpcomingTable :offers="offersPublished" :entityId="entityId"></UpcomingTable>

          <div class="mt-2 text-center">
            <a class="btn btn-secondary-dark btn-sm" @click="redirectOfferTab('published')">
              {{ $t('Statistic.BtnShowMoreLess.see_more') }}</a>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="waiting-wrapper">
        <sub-title
          :subTitle="$t('DashboardPageManager.waiting')"
          :number="countOffersWaiting"
          :color="'purple'">
        </sub-title>

        <div class="table-waiting">
          <UpcomingTable :offers="offersWaiting" :entityId="entityId"></UpcomingTable>
          <p class="mt-2 text-center">
            <a class="btn btn-secondary-dark btn-sm" @click="redirectOfferTab('waiting')">
              {{ $t('Statistic.BtnShowMoreLess.see_more') }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import offers_mixin from '@/mixin/offers'
  import TitleBlock from "./TitleBlock";
  import UpcomingTable from "./UpcomingTable";
  import SubTitle from "./SubTitle";
  import AtInternetManager from '@/helpers/at_internet/manage_requests'

  const DEFAULT_OFFER = {
    id: '',
    start_at: '',
    occupations: [],
    services: []
  };

  const LIMIT_PUBLISHED = 3;
  const LIMIT_WAITING = 5;

  export default {
    name: "UpcomingBlock",
    mixins: [offers_mixin],
    props: ['entityId'],
    components: {
      TitleBlock,
      UpcomingTable,
      SubTitle
    },
    data: function() {
      return ({
        is_actived: true,
        isMyRequest: true
      })
    },
    computed: {
      ...mapGetters({
        tabName: 'offers/selectedTab',
        listOfferPublished: 'dashboard/listOfferPublished',
        listOfferWaiting: 'dashboard/listOfferWaiting'
      }),
      logoBlockUrl() {
        return require('@/assets/img/pages/icons/icons8-important-mail-100.png')
      },
      offersPublished() {
        var list = []
        if(this.listOfferPublished) {
          list = this.setListData(this.listOfferPublished.data, LIMIT_PUBLISHED)
        }
        return list
      },
      countOffersPublished() {
        var count = 0
        if(this.listOfferPublished) {
          count = this.listOfferPublished.count
        }
        return count
      },
      offersWaiting() {
        var list = []
        if(this.listOfferWaiting) {
          list = this.setListData(this.listOfferWaiting.data, LIMIT_WAITING)
        }
        return list
      },
      countOffersWaiting() {
        var count = 0
        if(this.listOfferWaiting) {
          count = this.listOfferWaiting.count
        }
        return count
      }
    },
    methods: {
      offersPublishedByMe: function() {
        this.isMyRequest = true
        this.is_actived = true
        this.changeParamsOffer()
        AtInternetManager.sendSeeMyRequestsEvent()
      },
      offersPublishedAll: function() {
        this.isMyRequest = false
        this.is_actived = false
        this.changeParamsOffer()
        AtInternetManager.sendSeeAllMyRequestsEvent()
      },
      showDetails(offer) {
        var admin = { name: 'AdminOffer', params: { id: offer.id } }
        this.$router.push(admin)
      },
      setListData(offers, count) {
        var emptyOffers = Array(count - offers.length).fill(DEFAULT_OFFER)
        return [...offers, ...emptyOffers]
      },
      redirectOfferTab(tabName) {
        const publishedIds = this.is_actived ? [this.currentUser.id] : []
        const params = {
          filters: {
            entity_id_in: this.entityId,
            published_by_id_in: publishedIds
          }
        };

        this.$store.dispatch('offers/selectTab', tabName);
        this.$router.push({ name: "Offers", params: params });
      },
      initTab: function(){
      },
      changeParamsOffer() {
        let params = { 'is_my_request': this.isMyRequest, entity_id_in: this.entityId }
        this.$store.dispatch('dashboard/offersPublished', params)
        this.$store.dispatch('dashboard/offersWaiting', params)
      }
    },
    watch: {
      entityId: {
        handler() {
          this.changeParamsOffer()
        }
      },
      isMyRequest: {
        handler() {
          this.changeParamsOffer()
        }
      },
      deep: true
    },
    mounted: async function () {
      this.changeParamsOffer()
    }
  }
</script>

<style lang="scss" scoped>
  .button-wrapper {
    display: flex;

    .btn {
      border-radius: 40px;
      font-weight: 500;
      line-height: 16px;
      padding: 4px 15px;
    }

    .btn-ellipsis {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/manager/UpcomingBlock.vue